import { keysWithMap, nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
import { Question, RadioButtonQuestion } from './question-codecs';
export var StageTypes = keysWithMap({
  AdvocateAcceptanceStage: 'AdvocateAcceptanceStage',
  ApiIntegrationStage: 'ApiIntegrationStage',
  CheckInStage: 'CheckInStage',
  CorporateConfirmationStage: 'CorporateConfirmationStage',
  DiscussionReplyStage: 'DiscussionReplyStage',
  FileUploadStage: 'FileUploadStage',
  ImageUploadStage: 'ImageUploadStage',
  VideoUploadStage: 'VideoUploadStage',
  InfluitiveGroupJoinStage: 'InfluitiveGroupJoinStage',
  NpsStage: 'NpsStage',
  OnlineActionStage: 'OnlineActionStage',
  QuestionsStage: 'QuestionsStage',
  QuizStage: 'QuizStage',
  ReviewStage: 'ReviewStage',
  G2ReviewStage: 'G2ReviewStage',
  ShareLinkStage: 'ShareLinkStage',
  ReferralSocialShareStage: 'ReferralSocialShareStage',
  TwitterFollowStage: 'TwitterFollowStage',
  TwitterPostStage: 'TwitterPostStage',
  UpdateProfileStage: 'UpdateProfileStage'
});
var StageBase = t.type({
  id: t.string,
  name: t.string,
  position: t.number,
  description: nullable(t.string),
  points: t.number,
  completionText: nullable(t.string),
  notificationMessage: nullable(t.string),
  challenge: t.type({
    id: t.string
  })
});
var PublicResponsesInterface = t.type({
  responsesArePublic: t["boolean"],
  publicResponses: nullable(t.type({
    totalCount: t.number
  }))
});
export var AdvocateAcceptanceStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.AdvocateAcceptanceStage)
})]);
export var ApiIntegrationStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.ApiIntegrationStage)
})]);
export var CheckInStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.CheckInStage),
  fenceRadius: nullable(t.number),
  latitude: nullable(t.number),
  location: nullable(t.string),
  longitude: nullable(t.number)
})]);
export var CorporateConfirmationStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.CorporateConfirmationStage)
})]);
var Member = t.type({
  id: t.string,
  name: t.string,
  avatarUrl: nullable(t.string)
});
var SystemUser = t.type({
  id: t.string,
  name: t.string
});
var Author = t.union([Member, SystemUser]);
export var Topic = t.type({
  __typename: t.literal('Topic'),
  id: t.string,
  author: Author,
  createdAt: t.string,
  title: t.string,
  category: t.type({
    id: t.string,
    name: t.string
  })
});
export var DiscussionReplyStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.DiscussionReplyStage),
  previewDescription: t.string,
  previewImageUrl: t.string,
  previewTitle: t.string,
  previewHideImage: t["boolean"],
  url: t.string,
  topic: Topic
})]);
export var InfluitiveGroupJoinStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.InfluitiveGroupJoinStage)
})]);
export var NpsStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.NpsStage),
  question: Question
})]);
export var OnlineActionStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.OnlineActionStage),
  previewDescription: t.string,
  previewImageUrl: t.string,
  previewTitle: t.string,
  previewHideImage: t["boolean"],
  url: nullable(t.string),
  ctaButtonText: t.string
})]);
export var QuestionsStage = t.intersection([StageBase, PublicResponsesInterface, t.type({
  __typename: t.literal(StageTypes.map.QuestionsStage),
  questions: nullable(t.array(Question))
})]);
export var QuizStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.QuizStage),
  questions: nullable(t.array(RadioButtonQuestion))
})]);
export var ReviewStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.ReviewStage),
  previewDescription: t.string,
  previewImageUrl: t.string,
  previewTitle: t.string,
  previewHideImage: t["boolean"],
  url: nullable(t.string),
  ctaButtonText: t.string
})]);
export var G2ReviewStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.G2ReviewStage),
  previewDescription: nullable(t.string),
  previewImageUrl: nullable(t.string),
  previewTitle: nullable(t.string),
  url: nullable(t.string)
})]);
export var SocialShareProvidersEnum = t.keyof({
  facebook: null,
  twitter: null,
  linkedin: null
});
export var ShareLinkStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.ShareLinkStage),
  facebook: t["boolean"],
  twitter: t["boolean"],
  linkedin: t["boolean"],
  defaultText: nullable(t.string),
  previewDescription: nullable(t.string),
  previewImageUrl: nullable(t.string),
  previewTitle: nullable(t.string),
  shareURL: nullable(t.string),
  sharedIn: t.array(SocialShareProvidersEnum),
  minimumCharacters: nullable(t.number)
})]);
export var ReferralSocialShareStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.ReferralSocialShareStage),
  facebook: t["boolean"],
  twitter: t["boolean"],
  linkedin: t["boolean"],
  defaultText: nullable(t.string),
  previewDescription: nullable(t.string),
  previewImageUrl: nullable(t.string),
  previewTitle: nullable(t.string),
  url: nullable(t.string),
  sharedIn: t.array(SocialShareProvidersEnum),
  minimumCharacters: nullable(t.number)
})]);
var TwitterProfile = t.type({
  id: t.string,
  name: t.string,
  followersCount: t.number,
  profileImageUrl: t.string,
  handle: t.string
});
export var TwitterFollowStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.TwitterFollowStage),
  requiredFollowUser: TwitterProfile
})]);
export var TwitterPostStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.TwitterPostStage),
  contentType: nullable(t.keyof({
    mention: null,
    hashtag: null,
    reply: null
  })),
  defaultText: nullable(t.string),
  requiredContent: nullable(t.string),
  twitterPostId: nullable(t.string)
})]);
export var FileUploadStage = t.intersection([StageBase, PublicResponsesInterface, t.type({
  __typename: t.literal(StageTypes.map.FileUploadStage)
})]);
export var ImageUploadStage = t.intersection([StageBase, PublicResponsesInterface, t.type({
  __typename: t.literal(StageTypes.map.ImageUploadStage),
  question: Question
})]);
export var VideoUploadStage = t.intersection([StageBase, PublicResponsesInterface, t.type({
  __typename: t.literal(StageTypes.map.VideoUploadStage)
})]);
var PublicResponseStage = t.union([FileUploadStage, ImageUploadStage, QuestionsStage, VideoUploadStage]);
export var PublicResponseStageNames = t.keyof({
  FileUploadStage: null,
  ImageUploadStage: null,
  QuestionsStage: null,
  VideoUploadStage: null
});
export var UpdateProfileStage = t.intersection([StageBase, t.type({
  __typename: t.literal(StageTypes.map.UpdateProfileStage)
})]);
export var Stage = t.union([AdvocateAcceptanceStage, ApiIntegrationStage, CheckInStage, CorporateConfirmationStage, DiscussionReplyStage, FileUploadStage, ImageUploadStage, VideoUploadStage, InfluitiveGroupJoinStage, NpsStage, OnlineActionStage, QuestionsStage, QuizStage, ReviewStage, G2ReviewStage, ShareLinkStage, ReferralSocialShareStage, TwitterFollowStage, TwitterPostStage, UpdateProfileStage], 'Stage');